import { type RegistrationStatus } from '@exam-center/graphql';
import { Box, Flex, ReadonlyField, Text } from '@shared/components';

import { RegistrationStatusSelection } from '../registration-status-selection';

export interface ExamEventStatusFormFieldProps {
  registrationStatusOptions: RegistrationStatus[];
  reason?: string;
}

export default function ExamEventStatusFormField(props: Readonly<ExamEventStatusFormFieldProps>) {
  const { registrationStatusOptions, reason } = props;

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
      <Box sx={{ width: 240 }}>
        <Text variant='body1Semibold'>สถานะการรับสมัคร</Text>
      </Box>
      <Flex
        sx={{
          gap: (theme) => theme.spacing(4),
          minWidth: '400px',
          flexDirection: 'column',
        }}
      >
        <RegistrationStatusSelection name='status' options={registrationStatusOptions} />
        {reason ? (
          <ReadonlyField label='สาเหตุที่ปิดรับสมัครชั่วคราว' content={reason ?? ''} />
        ) : null}
      </Flex>
    </Flex>
  );
}
